import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import axios from "axios";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../config/api";

const AnnouncementSlider = () => {
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const response = await axios.get(
          getApiUrl("/ShowAnnouncements/"),
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        setAnnouncements(response.data);
      } catch (error) {
        console.error("Error fetching announcements:", error);
      }
    };

    fetchAnnouncements();
  }, []);

  // Slider settings
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 15000,
    prevArrow: <></>, // Hide the previous arrow
    nextArrow: <></>, // Hide the next arrow
  };

  return (
    <div className="recentContainer">
      <div className="row recentNews">
        <div className="col-2">
          {/* <h4 style={{ fontSize: "18px", textAlign: "center" }}>Recent Event</h4> */}
          {announcements.length > 0 && (
            <div className="mt-3 text-center">
              <h3 className="font-semibold text-white" style={{ fontSize: "1.2rem" }}>
                {announcements[0].title || ""}
              </h3>
            </div>
          )}
        </div>
        <div className="col-10 marqueeAnnouncement">
          {announcements.length > 0 ? (
            <Slider
              {...settings}
              className="p-1 rounded-lg "
            >
              {announcements.map((announcement) => (
                <div key={announcement.id} className="text-left">
                  <p style={{ fontSize: '1.1rem', fontWeight: "600" }}>{announcement.name}</p>
                </div>
              ))}
            </Slider>
          ) : (
            <p className="text-white text-center">
              No recent events available
            </p>
          )}
        </div>
      </div>

      {/* Title of the News Below "Recent Events" */}
    </div>
  );
};

export default AnnouncementSlider;
